import { List } from 'antd';
import styled from 'styled-components';

export const ApplicationsListSectionStyled = styled(`section`)`
	display: block;
	@media (max-width: 575px) {
		display: none;
	}
	margin-bottom: 48px;
`;

export const ApplicationsListGridStyled = styled(`div`)`
	gap: 24px;
	grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
	display: grid;
	padding: 160px;
`;

export const ListHeadingStyled = styled.h2`
	margin-bottom: 24px;
	font-size: 20px;
`;

export const ApplicationsListStyled = styled(List)`
	padding: 0;

	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		width: 496px;
	}

	@media (min-width: ${props => props.theme.breakpoints.md}) {
		width: 668px;
	}
	@media (min-width: ${props => props.theme.breakpoints.lg}) {
		width: 916px;
	}
	@media (min-width: ${props => props.theme.breakpoints.xl}) {
		width: 1200px;
	}
	@media (min-width: ${props => props.theme.breakpoints.xxl}) {
		width: 1200px;
	}
`;
